/**
 * @description
 */

import {fetchData} from '@umu/umu-fetch';

import Api from '../../../../path';
import {ESectionType, EPracticeQuestionStatus} from '@umu/umu-types';

export interface IInput {
    practice_id: number;
    element_id: number;
    question_id: number;
    element_type?: number;
    type: ESectionType;
    answer_ids: string; // number[].join(',');
}

export enum EIsSubmitQuestionRight {
    true = 1,
    false = 0,
}

export interface IOutput {
    status: EPracticeQuestionStatus;
    is_right: EIsSubmitQuestionRight;
}

export const submitQuestion = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.QUESTION_COLLECTION_SUBMIT_QUESTION, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
